/**
 * Meetverse feed freshness window, shared by every site that must move together:
 *
 *  - `useInfiniteMeetverseQuestions` default `staleTime` and the explicit
 *    `useHomeFeed` value (no auto-refetch inside the window)
 *  - the just-posted splice window (`JUST_POSTED_SPLICE_MS` in `./justPosted.ts`)
 *
 * AIDEV-NOTE: TECH-305 - load-bearing. staleTime keeps the optimistic prepend alive across
 * navigate-back/focus until Redis fan-out lands; the splice window must cover at least that
 * same period so a manual pull-to-refresh inside it cannot displace the post either. Tune
 * the value HERE so all three sites move together - forking the literal at one site silently
 * re-opens the disappearing-post hole at the others.
 */
export const MEETVERSE_FEED_STALE_TIME_MS = 2 * 60 * 1000;
